<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Profile|Telegram Notifications') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p v-if="botUsername">
              {{
                s__(
                  'Profile|These preferences control Telegram direct message notifications in your chat with the bot.'
                )
              }}
              {{
                sprintf(s__('Profile|Open Telegram, search for @%{botUsername} and tap "Start".'), {
                  botUsername,
                })
              }}
            </p>
            <p v-else>
              {{
                s__(
                  'Profile|These preferences control Telegram direct message notifications in your chat with the bot. Open Telegram, search for the bot, and tap "Start".'
                )
              }}
            </p>

            <h4>{{ s__('Profile|What you receive') }}</h4>
            <p>
              {{
                s__(
                  'Profile|You can receive Telegram DM notifications about task and calendar updates where you are involved.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Related settings') }}</h4>
            <p>
              {{
                s__(
                  'Profile|Event-specific toggles below control which events are sent. Silent hours apply only to Telegram DM notifications and do not affect email notifications.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Profile|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__, sprintf } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  botUsername: {
    type: String,
    default: null,
  },
})

const emit = defineEmits(['close'])

useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
